import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Loader } from '../../../../components/Loader';
import { HBox } from '../../../../components/Box';

import { UpdateInvoiceEmailModal } from '../../../Invoices/components/UpdateInvoiceEmailModal/UpdateInvoiceEmailModal';
import { fetchInvoice, getCurrentRestBpm, updateInvoiceGrossBpm, updateInvoiceOutgoingBpm } from '../../../Invoices/actions';
import { selectAutotelexBPM, selectInvoice } from '../../../Invoices/selectors';
import { selectConfig, selectWork, selectWorks } from '../../../Api/selectors';
import {
  GET_CURRENT_REST_BPM,
  INVOICE_DIRECTIONS,
  REQUEST_INVOICE,
  REQUEST_UPDATE_INVOICE,
  REQUEST_UPDATE_INVOICE_GROSS_BPM,
  REQUEST_UPDATE_INVOICE_OUTGOING_BPM,
  REQUEST_VAT_CODES,
} from '../../../Invoices/constants';
import { OnMouseOverNotification } from '../../../Vehicles/components/OnMouseOverNotification';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import styles from './FinFacturerenModal.module.css';
import env from '../../../../env';
import { AppClientId } from '../../../Shared/constants';
import { isPassengerVehiclePurposeScenario } from '../../../../utils/props';

const Container = styled.div`
  position: relative;
  width: 100%;

  box1 {
    h2 {
      font-size: 16px;
      text-transform: uppercase;
    }
  }

  .list {
    width: 100%;
  }

  .confirm-bpm-btn {
    margin-bottom: 16px;
  }
`;

const STATE = {
  value: null,
  valueGrossBpm: null,
  invoice: {},
};

/* eslint-disable react/prefer-stateless-function */
class FIN_facturerenModalComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.fetchInvoice(result => {
      this.setState({ invoice: result });
    });
    this.props.getCurrentRestBpm();
  }

  componentDidUpdate(prevProps, prevState) {}

  get needToUpdateOutgoingBPM() {
    if (this.props.serverConfig?.disableBPM) return false;
    if (this.state.invoice?.type !== 'invoice') return false;
    if (env.clientId == AppClientId.WIENTJES) return false;

    return (
      this.state.invoice?.direction === 'outgoing' &&
      ((this.state.invoice?.subjectType === 'vehicle' && !this.state.invoice?.ledgersEntry?.needBPMInvoice) ||
        this.state.invoice?.subjectType === 'BPM') &&
      !this.state.invoice?.vehicle?.new_from_factory &&
      this.state.invoice?.vehicle?.vehiclePurpose !== 'commercial' &&
      this.state.invoice?.vehicle?.financialAmounts?.rest_bpm != 0
    );
  }

  get needToUpdateEmail() {
    return this.invoice?.direction == INVOICE_DIRECTIONS?.OUTGOING && this.invoice?.subjectType == 'vehicle';
  }

  get oldValue() {
    const targetSubject = this.state.invoice?.invoiceSubjects?.find(s => ['vehicle', 'BPM'].includes(s.type));
    return targetSubject?.outgoing_rest_bpm;
  }

  get autotelexValue() {
    return this.props?.fetchedBpm?.autotelexRestBpm;
  }

  get value() {
    return this.state.value !== null ? this.state.value : this.autotelexValue;
  }

  get oldValueGrossBpm() {
    const targetSubject = this.state.invoice?.invoiceSubjects?.find(s => ['vehicle'].includes(s.type));
    console.log('!!! targetSubject !!!', targetSubject);
    return targetSubject?.financial_bpm_gross;
  }

  get autotelexValueGrossBpm() {
    return this.props?.fetchedBpm?.autotelexGrossBpm;
  }

  get valueGrossBpm() {
    return this.state.valueGrossBpm !== null ? this.state.valueGrossBpm : this.autotelexValueGrossBpm;
  }

  get functionName() {
    return this.props.functionName;
  }

  get isShowisTaxiAlert() {
    return (
      (this.functionName == 'IDWE_FIN_factureren_combine' || this.functionName == 'IDWEFINfactureren_combine_akkoord') &&
      this.props.vehicle?.taxiVerleden == '1'
    );
  }

  onConfirmBPMModal(value) {
    this.props.updateInvoiceOutgoingBpm(value, data => {
      if (data?.success) {
        this.props.fetchInvoice(result => {
          this.setState({ invoice: result });
        });
        this.props.getCurrentRestBpm();
        this.setState({ value: '' });
      }
    });
  }

  onConfirmGrossBPMModal(value) {
    this.props.updateInvoiceGrossBpm(value, data => {
      if (data?.success) {
        this.props.fetchInvoice(result => {
          this.setState({ invoice: result });
        });
        this.props.getCurrentRestBpm();
      }
    });
  }

  renderGrossBpmSection() {
    const vehicle = this.props.vehicle;
    return (
      <>
        {this.props.workUpdateGrossBpm ? (
          <Loader small />
        ) : (
          <div>
            <div style={{ color: 'red' }}>
              {!vehicle.regplate && vehicle.outgoing_rest_bpm ? this.lbl('kanbanboards.cell.regplate_empty_warning') : ''}
            </div>

            <label className="form-label">{this.lbl('kanbanboards.cell.currentGrossBpm')}</label>
            <input className="form-control" name="oldValueGrossBpm" value={this.oldValueGrossBpm} disabled={true} />

            <label className="form-label">{this.lbl('kanbanboards.cell.autotelexGrossBpm')}</label>
            <input
              className="form-control"
              name="autotelexValueGrossBpm"
              value={this.autotelexValueGrossBpm}
              disabled={true}
            />

            <label className="form-label">{this.lbl('kanbanboards.cell.update')}</label>
            <input
              className="form-control"
              name="valueGrossBpm"
              value={this.valueGrossBpm}
              onChange={this.onInputChange.bind(this)}
            />
          </div>
        )}

        <div className="mt-2">
          <ButtonComponent
            style={'ButtonSoftEdit'}
            disabled={this.props.workUpdateGrossBpm}
            onClick={() => this.onConfirmGrossBPMModal(this.valueGrossBpm)}
          >
            {this.lbl('kanbanboards.cell.confirm_gross_bpm')}
          </ButtonComponent>
        </div>
      </>
    );
  }

  renderOutgoingBPMSection() {
    return (
      <>
        <HBox left baseline gap={'8px'}>
          <label className="form-label">{this.lbl('currentValue')}</label>
          {this.isShowisTaxiAlert && (
            <OnMouseOverNotification message={this.lbl('alert.is_taxi_tax_message')} top="-100px" left="-90px" />
          )}
        </HBox>
        <input className="form-control" name="oldValue" value={this.oldValue} disabled={true} />

        <label className="form-label">{this.lbl('kanbanboards.cell.autotelexValue')}</label>
        <input className="form-control" name="autotelexValue" value={this.autotelexValue} disabled={true} />

        <label className="form-label">{this.lbl('kanbanboards.cell.update')}</label>
        <input className="form-control" name="value" value={this.value} onChange={this.onInputChange.bind(this)} />
        <div className="mt-2">
          <ButtonComponent style={'ButtonSoftEdit'} onClick={() => this.onConfirmBPMModal(this.value)}>
            {this.lbl('kanbanboards.cell.confirm_outgoing_bpm')}
          </ButtonComponent>
        </div>
      </>
    );
  }

  render() {
    if (this.props.workInvoice || this.props.workBpm) return <Loader small />;
    const invoice = this.state.invoice;
    const vehicle = this.props.vehicle;
    return (
      <Container innerWidth={window.innerWidth}>
        {isPassengerVehiclePurposeScenario(vehicle?.vehicle_purpose) && this.renderGrossBpmSection()}
        {this.props.workUpdateBpm ? (
          <Loader small />
        ) : (
          <div>
            <div className={styles.text}>
              <div>
                {!vehicle.regplate && vehicle.outgoing_rest_bpm ? this.lbl('kanbanboards.cell.regplate_empty_warning') : ''}
              </div>
              <div>{vehicle.new_from_factory == '1' ? this.lbl('kanbanboards.cell.new_from_factory') : ''}</div>
              <div>{vehicle.import == '1' ? 'Import met KM stand: ' + vehicle?.mileage : ''}</div>
            </div>
            {isPassengerVehiclePurposeScenario(vehicle?.vehicle_purpose) && this.renderOutgoingBPMSection()}
          </div>
        )}
        {this.props.workEmail ? (
          <Loader small />
        ) : (
          <UpdateInvoiceEmailModal invoice={invoice} needToUpdateEmail={this.needToUpdateEmail} />
        )}
      </Container>
    );
  }
}

FIN_facturerenModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    invoice: selectInvoice(ownProps.invoiceId),
    workInvoice: selectWorks([REQUEST_INVOICE, REQUEST_VAT_CODES]),
    workBpm: selectWork(GET_CURRENT_REST_BPM),
    workUpdateBpm: selectWork(REQUEST_UPDATE_INVOICE_OUTGOING_BPM),
    workUpdateGrossBpm: selectWork(REQUEST_UPDATE_INVOICE_GROSS_BPM),
    workEmail: selectWork(REQUEST_UPDATE_INVOICE),
    fetchedBpm: selectAutotelexBPM(),
    serverConfig: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchInvoice(callback) {
      dispatch(fetchInvoice(ownProps.invoiceId, callback, { isUniqueGate: true }));
    },
    getCurrentRestBpm() {
      dispatch(getCurrentRestBpm(ownProps.vehicle?.id));
    },
    updateInvoiceOutgoingBpm(value, callback) {
      dispatch(updateInvoiceOutgoingBpm(ownProps.invoiceId, value, callback));
    },
    updateInvoiceGrossBpm(value, callback) {
      dispatch(updateInvoiceGrossBpm(ownProps.invoiceId, value, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const FIN_facturerenModal = compose(withConnect, withRouter)(FIN_facturerenModalComp);
